var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmarkInCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm5.39 6.12-5.77 9.32a.14.14 0 0 1-.22 0l-4.63-3.87a.76.76 0 0 1-.09-1.07l.59-.69a.76.76 0 0 1 1.07-.09l2.47 2.09a.16.16 0 0 0 .23 0l4.28-6.92a.75.75 0 0 1 1-.25l.78.48a.75.75 0 0 1 .29 1Z"
})));
export default SvgCheckmarkInCircle;